




























































































import {Component, Vue} from "vue-property-decorator";
import ApiTable from "@/components/ApiTable/ApiTable.vue";
import {Action, Getter} from "vuex-class";
import {ICrudOptions} from "@/service/interfaces/ICrudOptions";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import AuthService from "@/service/AuthService";
import TableActionDelete from "@/components/ApiTable/ActionButtons/TableActionDelete.vue";
import NewCommentModal from "@/views/Service/TimeTracking/Modals/NewCommentModal.vue";
import Comments from "@/views/Service/TimeTracking/TimeTable/Comments.vue";
import ApiService from "@/service/ApiService";
import AppConfig from "@/config/AppConfig";
import ContinueRecord from "@/views/Service/TimeTracking/Modals/ContinueRecord.vue";
import ITimeTrackingTask from "@/models/TimeTracking/ITimeTrackingTask";


const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';

@Component({
  components: {ContinueRecord, Comments, NewCommentModal, TableActionDelete, ApiTable}
})
export default class TimeTrackingTimeTable extends Vue {
  public name: string = "TimeTrackingTimeTable";

  @Action('load', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) load: any;
  @Action('updateItem', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) updateRecord: any;
  @Action('deleteItem', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) deleteRecord: any;

  @Getter('getRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) runningTimeTrackingRecord: any;
  @Getter('getPaginationData', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) paginationData: any;
  @Getter('getDataList', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) dataList: any;
  @Getter('isLoading', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) isTableLoading: any;


  private lastParams: any = {};
  private editRow: number = -1;
  private authService: AuthService = new AuthService();

  private isNewCommentModalVisible: boolean = false;
  private newCommentTimeTrackingRecord: ITimeTrackingRecord | null = null;


  private get crudOptions(): ICrudOptions {
    return {
      resource: RESOURCE_TIME_TRACKING_RECORD

    }

  }

  private continueTask(timeTracking: ITimeTrackingRecord) {

    let task: ITimeTrackingTask = {
      ...timeTracking.task,
      client: timeTracking.client,
      brand: timeTracking.brand,
      type: timeTracking.type,
      records: timeTracking.all_task_items_stats.records
    };

    this.$emit('continue-task', task);

  }


  private exportTimeTable(): void {

    let path: string = "/tt/record/export";

    let as: ApiService = new ApiService();

    as.download(path, {params: this.lastParams, filename: 'time_tracking_export.xlsx'})

  }

  private onReloadTable(params: any) {

    this.lastParams = params;

    let crudOptions: ICrudOptions = {
      ...this.crudOptions,
      params: {
        ...this.crudOptions.params,
        ...params
      }
    };

    this.load(crudOptions);

  }

  private onFiltersChanged(params: any) {

    this.onReloadTable(params);

  }

  private onNewComment(record: ITimeTrackingRecord) {

    this.newCommentTimeTrackingRecord = record;
    this.isNewCommentModalVisible = true;

  }

  private onNewCommentVisibleChanged(visible: boolean) {

    this.isNewCommentModalVisible = visible;

  }

  private onPerPageChanged(params: any) {

    this.onReloadTable(params);

  }

  private onPageChanged(params: any) {

    this.onReloadTable(params);

  }

  private onSaveRow(data: any) {

    this.updateRecord({id: data.row.id, resource: RESOURCE_TIME_TRACKING_RECORD, data: data.values})
        .then(() => {

          this.editRow = -1;

        })
    ;

  }

  private onRemoveRecord(id: number) {

    this.deleteRecord({resource: RESOURCE_TIME_TRACKING_RECORD, id: id});

  }

  private setEditRow(rowIdx: number) {

    this.editRow = rowIdx;

  }

  private setEventListeners(): void {

    let id: number | null = this.authService.getUserId();

    this.$echo.private(`TimeTrackingRecord.${id}`)

        .listen('TimeTracking\\UserHasUpdatedRecord', (e) => {

          if (this.dataList) {

            this.dataList.forEach((record: ITimeTrackingRecord, idx: number) => {

              if (record.id === e.timeTracking.id) {

                this.dataList[idx] = e.timeTracking;

              }

            });

          }

        })
        .listen('TimeTracking\\UserHasStoredNewComment', (e) => {

          if (this.dataList) {

            this.dataList.forEach((record: ITimeTrackingRecord, idx: number) => {

              if (record.id === e.timeTracking.id) {

                this.dataList[idx]['comments'] = e.timeTracking.comments;
                this.dataList[idx]['total_comments_count']++;

              }

            });

          }

        })
        .listen('TimeTracking\\UserHasRemovedRecord', (e) => {

          if (this.dataList) {

            this.dataList.forEach((record: ITimeTrackingRecord, idx: number) => {

              if (record.id === e.timeTracking.id) {

                this.dataList.splice(idx, 1);

              }

            });

          }

        });

  }

  created() {

    this.onReloadTable(this.lastParams);

    this.setEventListeners();

  }

}
